// This file will go obsolete once websockets are implemented
import $ from 'jquery';
import Cookies from './libs/tomcat-cookies.js';
import notifications from './notifications.js';
import login from './login.js';

const interval = 300000; // 5 min
let sessionKey;

function checkStatus() {
	sessionKey = Cookies.get('sessionId');
	if (sessionKey) {
		$.ajax({
			url: '/player/status',
			type: 'GET',
			contentType: 'application/json; charset=utf-8'
		}).done((resultData) => {
			if (resultData.status === 'SUCCESS') {
				try {
					sessionKey = resultData.result.map.sessionKey;
					if (sessionKey === undefined || sessionKey === '') {
						logout(resultData.result.map.message);
					}
				}catch(err) {
					console.error('GET PLAYER STATUS FAILED', err);
					logout('Logout');
				}
			}
			if (resultData.status === 'FAILURE') {
				console.error(`${resultData.errorDescription}. Code: ${resultData.errorCode}`);
				logout('Logout');
			}
		}).fail((jqXHR, textStatus, errorThrown) => {
			console.error('GET PLAYER STATUS FAILED', errorThrown);
			logout('Logout');
		});
	}
}

function logout(errorMsg)  {
	login.doLogout();
	notifications.showNotification(errorMsg, 'red', true);
}

window.addEventListener('focus', () => {
	checkStatus();
});

function init() {
	setInterval(checkStatus, interval);
}

const playerStatus = {
	checkStatus,
	init
};

export default playerStatus;




// WEBPACK FOOTER //
// ./mobile-core/src/player-status.js